import { render, staticRenderFns } from "./medication.vue?vue&type=template&id=65d19ac0&scoped=true&"
import script from "./medication.vue?vue&type=script&lang=js&"
export * from "./medication.vue?vue&type=script&lang=js&"
import style0 from "./medication.vue?vue&type=style&index=0&id=65d19ac0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d19ac0",
  null
  
)

export default component.exports